import Hls from 'hls.js';

const sources = document.querySelectorAll(
    'video:has(source[type="application/vnd.apple.mpegurl"])',
);

sources.forEach(video => {
    const source = video.querySelector('source[type="application/vnd.apple.mpegurl"]');

    // HLS is natively supported
    if (video.canPlayType('application/vnd.apple.mpegurl')) {
        return;
    }

    if (!Hls.isSupported()) {
        console.warn('HLS.js is not supported in this browser.');
        return;
    }

    const hls = new Hls({
        capLevelToPlayerSize: true,
        autoStartLoad: false,
    });
    hls.loadSource(source.src);
    hls.attachMedia(video);

    video.addEventListener(
        'play',
        () => {
            hls.startLoad(-1);
        },
        {
            once: true,
        },
    );
});
